import { englishValidationMessages } from './messages';
import { getMaxLengthValidator, getMinLengthValidator, getPatternValidator } from './rawValidators';
import { getRequiredValidator } from './required';
const maxLength = 30;
const minLength = 3;
const maxLengthValidator = getMaxLengthValidator(maxLength);
const minLengthValidator = getMinLengthValidator(minLength);
const cityNamePatternValidator = getPatternValidator(/^[a-zA-Z0-9 ,.()'-]*$/);
export function getCityNameFailure(value) {
    if (!minLengthValidator(value)) {
        return 'tooShort';
    }
    if (!maxLengthValidator(value) || !cityNamePatternValidator(value)) {
        return 'invalid';
    }
    return null;
}
export const makeCityNameValidators = (messages)=>{
    /** true means there's no error. false means there's an error. string means there's an error and gives the error-message. */ function getCityNameFailureMessages() {
        let valueName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : messages.fieldNames.cityName;
        return {
            tooShort: messages.tooShort({
                field: valueName,
                min: minLength
            }),
            invalid: messages.invalid({
                field: valueName
            })
        };
    }
    function getCityNameValidator() {
        let valueName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : messages.fieldNames.cityName, required = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        const requiredValidator = getRequiredValidator(required);
        const failureErrors = getCityNameFailureMessages(valueName);
        return (value)=>{
            const requiredError = requiredValidator(value);
            if (requiredError !== true) {
                return requiredError;
            }
            const failure = getCityNameFailure(value);
            return failure == null ? true : failureErrors[failure];
        };
    }
    /** For react-hook-form library. */ const cityNameValidation = function cityNameValidation(valueName) {
        let { required } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return {
            validate: {
                cityName: getCityNameValidator(valueName, required)
            },
            dataAttr: {
                'data-validation': 'city'
            }
        };
    };
    return {
        getCityNameFailureMessages,
        getCityNameValidator,
        cityNameValidation
    };
};
export const { getCityNameFailureMessages, getCityNameValidator, cityNameValidation } = makeCityNameValidators(englishValidationMessages);
